import { useState, useContext, useEffect } from "react";
import { AppContext } from "../../Context";
import { Preloader } from "../Preloader";

const Form = () => {
  const { insertDto, lookup, getItemlookup } = useContext(AppContext);
  const [newDto, setNewDto] = useState({});
  const [fqtde, setFqtde] = useState();
  const [fpreco, setFpreco] = useState();
  const [ftotal, setFtotal] = useState(); 
  const [showPreloader, setShowpreloader] = useState();
  
    useEffect(() => {
        setShowpreloader(false);
        setNewDto({
            ...newDto,
            aceito: "0",
            contato: "",
            quantidade: "1",
            precounitario: "0.00",
            total: "0.00",
        });
    }, []);

  const resetDto = () => {
    setNewDto({
        ...newDto,
        aceito: "0",
        contato: "",
        quantidade: "1",
        precounitario: "0.00",
        total: "0.00",
    });
  }

  const updateTotal = (e) => {
    if (e.target.name === "_quantidade")
        setFqtde(e.target.value);
    if (e.target.name === "_precounitario")
        setFpreco(e.target.value);  
    if (fqtde * fpreco >= 0)
        setFtotal((fqtde * fpreco).toFixed(2));
  };

  // Storing the Insert User Form Data.
  const addNewDto = (e, field) => {
    if (e !== null) {
        let tarefa = getItemlookup(newDto.idorcamento); 
        
        let aceito = newDto.aceito;        
        if (field === "aceito")
            aceito = (aceito === "1" && !e.target.value ? "0" : "1");

        updateTotal(e);
        setNewDto({
            ...newDto,
            [field]: e.target.value,
            tarefa: tarefa,
            total: ftotal,
            aceito: aceito,
        });
    } 
  };

  // Inserting a new user into the Database.
  const submitDto = (e) => {
    setShowpreloader(true);
    e.preventDefault();
    insertDto(newDto);
    e.target.reset();
    setFqtde(1);
    setFpreco(0);
    setFtotal(0);
    resetDto();
    setShowpreloader(false);
    //toastSuccess('Tarefa inserida com sucesso!');
  };

  return (
    <form className="insertForm" onSubmit={submitDto}>
      <div className="row">
        <h4>Cadastro</h4>
      </div>
 
      <div className="row">
                <div className="input-field col s6">
                    <span className="labelfake">Tarefa e Responsável</span>
                        <select id="_tarefa" className="browser-default"
                            onChange={(e) => addNewDto(e, "idtarefa")}
                            required>
                        <option key={-1} value="0" disabled selected>Selecione uma tarefa</option>
                            {lookup.map((lkp) => {
                                return <option key={lkp.idtarefa} value={lkp.idtarefa}>{lkp.nome}</option>
                            })}
                        </select> 
                    </div>
                    <div className="input-field col s6">
                    <span className="labelfake">Fornecedor</span>
                        <input
                            type="text"
                            name="_fornecedor"
                            className="validate"
                            onChange={(e) => addNewDto(e, "fornecedor")}/>
                    </div>
                </div>

                <div className="row">
                    <div className="input-field col s12">
                    <span className="labelfake">Contato</span>
                        <input
                            type="text"
                            name="_contato"
                            className="validate"
                            onChange={(e) => addNewDto(e, "contato")}/>
                    </div>
                </div>
                <div className="row">
                    <div className="input-field col s2">
                        <span className="labelfake">Quantidade</span>
                        <input
                            type="number"
                            name="_quantidade"
                            defaultValue={1}
                            onBlur={(e) => updateTotal(e)}
                            onChange={(e) => addNewDto(e, "quantidade")}/>
                    </div>
                    <div className="input-field col s1"><br/>x</div>
                    <div className="input-field col s2">
                        <span className="labelfake">Preço Unitario</span>
                        <input
                            type="number"
                            name="_precounitario"
                            min={0.00}
                            max={9999.99}
                            defaultValue={0.00}
                            onBlur={(e) => updateTotal(e)}
                            onChange={(e) => addNewDto(e, "precounitario")}/>
                    </div>
                    <div className="input-field col s1"><br/>=</div>
                    <div className="input-field col s3">
                        <span className="labelfake">Total</span>
                        <input
                            type="number"
                            name="_total"
                            value={ftotal} 
                            defaultValue={0.00}
                            onChange={(e) => addNewDto(e, "total")}/>
                    </div>
                    <div className="input-field col s3">
                        <span className="labelfake">Proposta aceita</span>
                        <div className="switch">
                            <label>
                                Não
                                <input
                                    type="checkbox"
                                    name="_aceito"
                                    defaultChecked={false} 
                                    onClick={(e) => addNewDto(e, "aceito")}/>
                                <span className="lever"></span>
                                Aceito
                            </label>
                        </div>
                    </div>
                </div>
                {showPreloader ? <Preloader/> : <input type="submit" value="Inserir" />}
    </form>
  );
};

export default Form;